export default "__VITE_ASSET__ClLPw94s__"